import { api } from 'store/api';
import { ApiResponse } from 'store/api/types';
import { SubscriptionType } from './models/subscriptionType';
import { PlanPricingDetails } from './models/planPricingDetails';
import { BillingCheckout } from './models/billingCheckout';
import { CurrentSubscription } from './models/currentSubscription';
import { Invoice } from './models/invoice';
import { BillingFormRequest } from './models/billingFormRequest';
import { ConatctUsRequest } from './models/conatctUsRequest';

export interface ValidateVATNumberResponse extends ApiResponse {
  data: { isValid: string };
}

export interface SubscriptionTypeResponse extends ApiResponse {
  data: { licenseTypes: SubscriptionType[] };
}

export interface ChangeSubscriptionPlanResponse extends ApiResponse {
  data: { message: string; statusCode: number };
}

export interface FetchPlanPricingDetailsResponse extends ApiResponse {
  data: { priceDetails: PlanPricingDetails; statusCode: number };
}

export interface CheckoutResponse extends ApiResponse {
  data: { responseBody: string; statusCode: number };
}

export interface GetCurrentSubscriptionResponse extends ApiResponse {
  data: { subscription: CurrentSubscription; statusCode: number };
}

export interface GetInvoicesResponse extends ApiResponse {
  data: { invoices: Invoice[]; statusCode: number };
}

export interface UpdateCardResponse extends ApiResponse {
  data: { url: string };
}

export interface CancelSubscriptionResponse extends ApiResponse {
  data: { responseBody: string; statusCode: number };
}

export interface GetBillingDetailsResponse extends ApiResponse {
  data: BillingFormRequest;
}

export const validateVATNumber = (
  countryCode: string,
  taxNumber: string
): Promise<ValidateVATNumberResponse> =>
  api.get<ValidateVATNumberResponse>(`/vies/check/${taxNumber}`);

export const fetchSubscriptionPlans = (): Promise<SubscriptionTypeResponse> =>
  api.get<SubscriptionTypeResponse>('/plan/types');

export const changeSubscriptionPlan = (
  subscriptionTypeId: string,
  billingCheckout: BillingCheckout
): Promise<ChangeSubscriptionPlanResponse> =>
  api.post<ChangeSubscriptionPlanResponse>(`/plan/change`, {
    body: {
      ...billingCheckout,
      typeId: subscriptionTypeId,
    },
  });

export const fetchPlanPricingDetails = (
  subscriptionTypeId: string
): Promise<FetchPlanPricingDetailsResponse> =>
  api.get<FetchPlanPricingDetailsResponse>(
    `/plan/details?planUuid=${subscriptionTypeId}`
  );

export const checkout = (
  billingCheckout: BillingCheckout
): Promise<CheckoutResponse> =>
  api.post<CheckoutResponse>('/payment/checkout', {
    body: {
      ...billingCheckout,
    },
  });

export const getCurrentSubscription = (
  accountId: string
): Promise<GetCurrentSubscriptionResponse> =>
  api.get<GetCurrentSubscriptionResponse>(
    `/payment/subscription?accountId=${accountId}`
  );

export const getInvoices = (customerId: string): Promise<GetInvoicesResponse> =>
  api.get<GetInvoicesResponse>(`/payment/invoice-link?accountId=${customerId}`);

export const updateCard = (accountId: string): Promise<UpdateCardResponse> =>
  api.post<UpdateCardResponse>(`/payment/update-card?accountId=${accountId}`);

export const cancelSubscription = (
  accountId: string
): Promise<CancelSubscriptionResponse> =>
  api.post<CancelSubscriptionResponse>(
    `/payment/cancel?accountId=${accountId}`
  );

export const getBillingDetails = (
  accountId: string
): Promise<GetBillingDetailsResponse> =>
  api.get<GetBillingDetailsResponse>(`/billing/${accountId}`);

export const saveBillingDetails = (
  accountId: string,
  billingDetails: BillingFormRequest
): Promise<ApiResponse> =>
  api.post<ApiResponse>(`/billing/${accountId}`, {
    body: { ...billingDetails },
  });

export const sendContactUsEmail = (
  contactUs: ConatctUsRequest
): Promise<ApiResponse> =>
  api.post<ApiResponse>('/contact', {
    body: { ...contactUs },
  });
